"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  /** product features max 3 features */
  productFeatures: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    header: _propTypes.string,
    value: _propTypes.string
  }))
};

var Features = function Features(_ref) {
  var _ref$productFeatures = _ref.productFeatures,
      productFeatures = _ref$productFeatures === void 0 ? [] : _ref$productFeatures;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: ["center", "center", "normal"],
    "data-test-id": "modules-features",
    flex: ["1 1 100%", "1 1 100%", "1 1 40%"],
    flexDirection: ["column", "row"],
    m: "auto",
    pb: [1, 3],
    pt: [0, 0, 3],
    px: [3, 3, 0]
  }, (0, _utils.mapIndexed)(function (_ref2, index) {
    var header = _ref2.header,
        value = _ref2.value;
    return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
      key: header,
      alignItems: "center",
      borderLeft: ["none", index === 0 ? "none" : "solid 1px"],
      borderLeftColor: "gray",
      borderTop: ["solid 1px", "none"],
      borderTopColor: "gray",
      flexDirection: "column",
      px: [0, 3, 2, 3],
      py: [2, 1],
      width: 1
    }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
      color: "gray-menu",
      "data-test-id": "modules-feature-header",
      fontSize: 1,
      letterSpacing: "0.43px",
      lineHeight: 3,
      mb: 1,
      textAlign: "center"
    }, header), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
      color: "body-grey",
      "data-test-id": "modules-feature-value",
      fontSize: 1,
      letterSpacing: "0.5px",
      lineHeight: 2,
      textAlign: "center"
    }, value));
  }, productFeatures));
};

Features.propTypes = propTypes;
Features.displayName = "Modules.Features";
var _default = Features;
exports["default"] = _default;